import { GuestModel } from 'api-hooks/guest';
import { AuthorizationRules } from 'common/constants';
import notification from 'components/common/notification';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer from 'hooks/use-drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ListCustomerPanel from '../components/list-customer/list-customer-panel';

export default function useGuestCustomerListAction(guest?: GuestModel) {
  const id = guest?.id;
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const { t } = useTranslation();

  const onViewListCustomer = React.useCallback(
    (currentId?: string) => {
      const _id = currentId ?? id;
      const message = {
        id: _id || 'undefined',
        message: 'Invalid Customer View Guest List Action (FE)',
      };

      if (!_id) {
        notification.error({
          message: JSON.stringify(message),
        });
        return;
      }

      drawer.showCustom({
        desktopDrawerWidthPercentage: 45,
        render: (onClose) => (
          <ListCustomerPanel guestId={_id} onClose={onClose} />
        ),
      });
    },
    [drawer, id],
  );

  const guestCustomerListPermission = can(
    AuthorizationRules.GuestsGetCustomers,
  );

  const guestCustomerListAction: PopoverMenuType = {
    key: `guest-customer-list-${id}`,
    label: t('customer:customer_list'),
    onClick: onViewListCustomer,
    isAllowed: guestCustomerListPermission,
  };

  return {
    guestCustomerListAction,
    onViewListCustomer,
    guestCustomerListPermission,
  };
}
